var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseTitleGenerator3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.874 58.6713C112.484 35.1046 93.8845 17.7761 71.704 13.7328L63.964 4.72202C63.5019 4.1444 62.8088 3.91336 62.1156 4.02888L37.9713 8.53428C37.2781 8.64981 36.7005 9.22742 36.4695 9.80504L32.5417 21.0108C13.2493 32.9097 2.27461 55.7833 6.66449 79.2345C7.2421 82.2381 8.05077 85.1261 8.97495 87.8987L5.04716 99.22C4.81612 99.9131 4.93164 100.606 5.39373 101.184L21.3359 119.783C21.798 120.361 22.4912 120.592 23.1843 120.476L34.9677 118.281C45.9424 124.289 58.881 126.599 72.1661 124.173C85.3358 121.747 96.657 114.816 104.628 105.227L116.296 102.917C116.989 102.801 117.567 102.339 117.798 101.646L125.884 78.5413C126.115 77.8482 126 77.1551 125.538 76.5774L117.798 67.5666C117.682 64.6785 117.451 61.6749 116.874 58.6713Z",
    fill: "#FF7AD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8034 111.595C87.4073 111.595 105.731 105.535 105.731 98.061C105.731 90.5866 87.4073 84.5273 64.8034 84.5273C42.1995 84.5273 23.8755 90.5866 23.8755 98.061C23.8755 105.535 42.1995 111.595 64.8034 111.595Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8035 107.801C98.3843 107.801 125.607 98.7858 125.607 87.6644C125.607 76.543 98.3843 67.5273 64.8035 67.5273C31.2226 67.5273 4 76.543 4 87.6644C4 98.7858 31.2226 107.801 64.8035 107.801Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0748 96.6197C27.7329 94.266 23.8755 91.1277 23.8755 87.6626C23.8755 80.2093 42.1819 74.1289 64.8034 74.1289C87.4249 74.1289 105.731 80.2093 105.731 87.6626C105.731 95.1159 87.4249 101.196 64.8034 101.196C58.9846 101.196 53.4273 100.804 48.393 100.085",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4522 43.7938C22.6334 37.3212 36.6901 28.168 42.7051 28.168C41.9205 32.0908 49.1777 33.9868 47.7394 37.3212",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4522 43.7938C22.6334 37.3212 36.6901 28.168 42.7051 28.168C41.9205 32.0908 49.1777 33.9868 47.7394 37.3212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0454 58.6992L28.518 83.609C28.518 85.7666 33.8138 87.5318 40.2865 87.5318C46.7591 87.5318 52.0549 85.7666 52.0549 83.609L58.5275 58.6992H22.0454Z",
    fill: "#FF7AD1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2392 59.6145C56.8276 59.2876 57.2853 59.0261 57.6775 58.6992H22.0454L23.5492 64.4527C29.7603 65.7603 43.3593 66.5448 56.2392 59.6145Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4243 56.8691L20.8682 52.4232L23.2872 45.2314L28.3869 41.6355L40.286 33.5938L45.9087 34.4437L54.0812 39.478L57.0887 45.9506L56.3695 50.0695L43.4243 56.8691Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0889 45.9513C59.1157 41.6362 55.6506 33.2021 41.7246 34.5751L57.0889 45.9513Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0889 45.9513C59.1157 41.6362 55.6506 33.2021 41.7246 34.5751",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8683 52.4232C17.2724 43.7276 28.0601 39.6741 39.5017 41.3086L20.8683 52.4232Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8683 52.4232C17.2724 43.7276 28.0601 39.6741 39.5017 41.3086",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0451 51.704C17.5992 53.7307 17.9262 58.6996 23.9411 60.7918C30.283 63.0147 49.9624 63.2108 59.1156 58.3727C65.5882 54.9076 65.1306 46.6697 50.0931 43.793",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0451 51.704C17.5992 53.7307 17.9262 58.6996 23.9411 60.7918C30.283 63.0147 49.9624 63.2109 59.1156 58.3727C65.5882 54.9076 65.1306 46.6697 50.0931 43.793",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2861 62.2305V87.5326",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7603 62.2305L34.9253 87.0749",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.074 61.0547L45.6475 87.076",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5107 58.6992L75.9834 83.609C75.9834 85.7666 81.2792 87.5318 87.7518 87.5318C94.2244 87.5318 99.5202 85.7666 99.5202 83.609L105.993 58.6992H69.5107Z",
    fill: "#FF7AD1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.143 62.1C105.601 61.6423 104.751 59.0271 105.143 58.7656H69.5107L71.4721 66.2843C73.2374 66.8728 74.3489 66.6112 76.2449 65.0421C79.187 66.0228 84.7443 67.5919 90.2362 63.996C93.9629 65.369 101.939 65.369 105.143 62.1Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8169 62.2305V87.5326",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2256 62.2305L82.456 87.0749",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6048 61.0547L93.1782 87.076",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8035 56.4089C67.4841 62.8816 73.9567 62.0316 77.4872 59.7433C83.1753 63.5354 87.8173 62.2278 92.9823 58.7626C98.2127 62.9469 106.516 64.4507 109.654 58.3703C114.754 48.4326 104.816 32.676 85.7905 32.676C66.7649 32.6106 62.1229 49.9363 64.8035 56.4089Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 35.3588C101.939 39.1508 98.8012 42.7467 95.0092 42.7467C94.0939 42.7467 93.2439 42.7467 92.394 41.766C88.9288 42.289 87.0328 37.974 87.6212 34.5088C88.275 30.7168 91.6094 28.1016 95.4015 28.1016C99.1935 28.1016 101.939 31.5667 101.939 35.3588Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9366 35.6875C90.9559 37.5181 90.6943 40.068 91.9366 42.2909",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.428 29.4742C98.2126 25.0937 93.4398 18.425 86.8364 20.5171",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1621 61.9023L50.5501 90.2773C50.5501 92.6964 56.565 94.7231 63.953 94.7231C71.3409 94.7231 77.3559 92.7617 77.3559 90.2773L84.7438 61.9023H43.1621Z",
    fill: "#FF7AD1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1286 62.882C82.7824 62.4897 83.3708 62.1628 83.7631 61.8359H43.1621L44.862 68.4393C51.9884 69.8777 67.4835 70.793 82.1286 62.882Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5493 59.7474L41.7896 54.7132L44.6009 46.4753L50.4197 42.3563L63.9534 33.2031L70.3606 34.1838L79.6446 39.9373L83.1751 47.3252L82.3252 51.9672L67.5493 59.7474Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4199 42.3546C46.3009 33.2014 59.7038 21.8906 66.5687 21.8906C65.6534 26.3365 67.6802 29.4747 70.3608 34.1821",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4199 42.3546C46.3009 33.2014 59.7038 21.8906 66.5687 21.8906C65.6534 26.3365 67.6802 29.4747 70.3608 34.1821",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1752 47.3218C85.5289 42.3529 81.5407 32.8074 65.6533 34.3111L83.1752 47.3218Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1752 47.3218C85.5289 42.3529 81.5407 32.8074 65.6533 34.3111",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7897 54.7124C37.7361 44.84 50.0276 40.198 63.0382 42.0286L41.7897 54.7124Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7897 54.7124C37.7361 44.84 50.0276 40.198 63.0382 42.0286",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1625 53.8613C38.1283 56.1496 38.5205 61.8376 45.3201 64.1913C52.5772 66.6758 75.0026 66.9373 85.398 61.4454C92.786 57.5226 92.1976 48.1078 75.068 44.7734",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1625 53.8613C38.1283 56.1496 38.5205 61.8376 45.3201 64.1913C52.5772 66.6758 75.0026 66.9373 85.398 61.4454C92.786 57.5226 92.1976 48.1078 75.068 44.7734",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8193 49.9375L54.4078 53.9257",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4985 48.957L75.8522 52.226",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6265 51.1797L67.68 51.5066",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2134 54.3175L84.4824 51.8984",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4229 58.1096L64.3457 57.1289",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5234 57.3281L51.9886 59.3549",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3413 41.961L75.1334 40.7188",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9531 65.8906V94.7232",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9233 65.8906L57.8729 94.2002",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3102 64.5195L70.0991 94.2021",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseTitleGenerator3);
export default __webpack_public_path__ + "static/media/use-title-generator-3.7adf7fca2af420f07262977226338ebb.svg";
export { ForwardRef as ReactComponent };